import { render, staticRenderFns } from "./environmentManagement.vue?vue&type=template&id=24ab4ad8&scoped=true&"
import script from "./environmentManagement.vue?vue&type=script&lang=js&"
export * from "./environmentManagement.vue?vue&type=script&lang=js&"
import style0 from "./environmentManagement.vue?vue&type=style&index=0&id=24ab4ad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab4ad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\project_nav_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ab4ad8')) {
      api.createRecord('24ab4ad8', component.options)
    } else {
      api.reload('24ab4ad8', component.options)
    }
    module.hot.accept("./environmentManagement.vue?vue&type=template&id=24ab4ad8&scoped=true&", function () {
      api.rerender('24ab4ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/productVavigation/environmentManagement.vue"
export default component.exports